import React from 'react';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_TASKS, ROUTE_SQL_AUTOMATIONS } from 'new/constants/pathnames';
import { ScreenComponent } from 'new/routes/RouterManager';
import Drawer from 'new/components/drawer/Drawer';
import structure, { StructureGroup, StructureItem } from 'new/routes/structure';
import styles from './Tasks.module.scss';
import { Redirect, Route, Switch } from 'react-router-dom';
import { router } from 'new/routes/router';
import PrivateRoute from 'js/components/route_utils/PrivateRoute';
import { useSectionNavigation, useLastVisitedPath } from 'new/hooks/useSectionNavigation';
import { useSqlAutomation } from 'new/hooks/useFeatureFlags';
import { useGrowthBookContext } from 'new/contexts/GrowthBookProvider';
import RouteLoadingComponent from 'js/components/route_utils/RouteLoadingComponent';
import SqlAutomationsUnavailable from './components/SqlAutomationsUnavailable';

const mapStructureItemToDrawerItem = (item: StructureItem): any => ({
  title: typeof item.title === 'string' ? item.title : String(item.title),
  to: item.to,
  onClick: item.onClick,
  Icon: item.Icon,
  BaseComponent: item.BaseComponent,
  badge: item.badge,
  isCollapsed: item.isCollapsed,
  isDisabled: item.isDisabled,
});

const mapStructureGroupToDrawerContent = (group: StructureGroup): any => ({
  name: group.name,
  badge: group.badge,
  items: group.items.map(mapStructureItemToDrawerItem),
});

const SIDEBAR_GROUPS = structure.find((s) => s.name === 'Tasks')?.groups?.() ?? [];
const MAPPED_SIDEBAR_GROUPS = SIDEBAR_GROUPS.map(mapStructureGroupToDrawerContent);

export const Tasks: ScreenComponent<any> = () => {
  useSectionNavigation('tasks');

  const { isReady: isGrowthBookReady } = useGrowthBookContext();
  const isTasksEnabled = useSqlAutomation();
  const defaultPath = `${ROUTE_REDESIGN}${ROUTE_SQL_AUTOMATIONS}`;
  const lastVisitedPath = useLastVisitedPath('tasks', ROUTE_TASKS, defaultPath);

  if (!isGrowthBookReady) {
    return <RouteLoadingComponent />;
  }

  if (!isTasksEnabled) {
    return <SqlAutomationsUnavailable />;
  }

  return (
    <Drawer content={MAPPED_SIDEBAR_GROUPS}>
      <div className={styles.container}>
        <Switch>
          {router.manager.getRoutes('tasks').map((route) => (
            <PrivateRoute key={route.name} {...route} />
          ))}
          <Route path="*">
            {lastVisitedPath ? <Redirect to={lastVisitedPath} /> : <Redirect to={defaultPath} />}
          </Route>
        </Switch>
      </div>
    </Drawer>
  );
};

Tasks.screenConfig = {
  path: `${ROUTE_REDESIGN}${ROUTE_TASKS}`,
  domain: 'main',
  screenName: 'Tasks',
  header: {
    title: 'Tasks',
  },
};
